export const separateDietIdAndTierIdsByUnderscore = ids => {
  const [dietId, tierId] = ids.split('_').map(Number);

  return { dietId, tierId };
};

export const getDietIdWithTierId = (dietId, tierId) => {
  return tierId ? `${dietId}_${tierId}` : dietId.toString();
};

export const getDietNameWithTierName = (dietName, tierName) => {
  return tierName ? `${dietName} - ${tierName}` : dietName;
};
